var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFailed = function SvgFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      height: "100%",
      width: "100%"
    }
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#BF0637"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 23.333c-9.183 0-16.667 7.483-16.667 16.667 0 9.183 7.484 16.666 16.667 16.666 9.183 0 16.667-7.483 16.667-16.666 0-9.184-7.484-16.667-16.667-16.667Zm-1.25 10c0-.683.567-1.25 1.25-1.25s1.25.567 1.25 1.25v8.333a1.26 1.26 0 0 1-1.25 1.25c-.683 0-1.25-.566-1.25-1.25v-8.333ZM41.533 47.3c-.083.216-.2.383-.35.55-.166.15-.35.266-.55.35a1.66 1.66 0 0 1-.633.133 1.66 1.66 0 0 1-.633-.133c-.2-.084-.384-.2-.55-.35a1.723 1.723 0 0 1-.35-.55 1.66 1.66 0 0 1-.134-.634c0-.216.05-.433.134-.633.083-.2.2-.383.35-.55.166-.15.35-.267.55-.35.4-.167.866-.167 1.266 0 .2.083.384.2.55.35.15.167.267.35.35.55.084.2.134.417.134.633 0 .217-.05.434-.134.634Z",
    fill: "#fff"
  })));
};
export default SvgFailed;